module.exports = __webpack_public_path__ + "static/fonts/font-number2-bold.ac8ce60.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/font/number/font-number2-bold.ttf
// module id = 3xHP
// module chunks = 4